/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentProps, ComponentType, FC } from 'react';

import { compose as composeBase, composeU as composeUBase } from '@bem-react/core';

// type Composition<T> = <U extends ComponentType<any>>(fn: U) => FC<JSX.LibraryManagedAttributes<U, ComponentProps<U>> & T>;

// type Composition<T> = <U extends ComponentType<any>>(fn: U) => FC<JSX.LibraryManagedAttributes<U, DeepUnion2<ComponentProps<U>, T>>>;

type Composition<T> = <U extends ComponentType<any>>(
    fn: U,
) => FC<DeepUnion2<T, JSX.LibraryManagedAttributes<U, ComponentProps<U>>>>;
type HOC<T> = (WrappedComponent: ComponentType) => ComponentType<T>;

// type Compose<Fns extends any[], Acc = {}> =
//     Fns extends [infer Item, ...infer T]
//         ? Item extends Composition<infer H>
//             ? Compose<T, Simplify<Acc & H>>
//                 : Item extends HOC<infer H>
//             ? Compose<T, Simplify<Acc & H>>
//                 : never
//         : Composition<Acc>;

export function compose<T1>(fn1: HOC<T1>): Composition<T1>;
export function compose<T1, T2>(fn1: HOC<T1>, fn2: HOC<T2>): Composition<T1 & T2>;
export function compose<T1, T2, T3>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
): Composition<T1 & T2 & T3>;
export function compose<T1, T2, T3, T4>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
): Composition<T1 & T2 & T3 & T4>;
export function compose<T1, T2, T3, T4, T5>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
): Composition<T1 & T2 & T3 & T4 & T5>;
export function compose<T1, T2, T3, T4, T5, T6>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
): Composition<T1 & T2 & T3 & T4 & T5 & T6>;
export function compose<T1, T2, T3, T4, T5, T6, T7>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
    fn7: HOC<T7>,
): Composition<T1 & T2 & T3 & T4 & T5 & T6 & T7>;
export function compose<T1, T2, T3, T4, T5, T6, T7, T8>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
    fn7: HOC<T7>,
    fn8: HOC<T8>,
): Composition<T1 & T2 & T3 & T4 & T5 & T6 & T7 & T8>;
export function compose(...fns: Array<HOC<any>>): Composition<any>;
// export function compose<Fns extends HOC<any>[]>(...fns: Fns): Compose<Fns> {

export function compose(...fns: Parameters<typeof composeBase>) {
    return composeBase(...fns);
}

type SafeUnionType<P, C> = P extends keyof C ? C[P] : never;

// type DeepUnion2<T1, T2> = {
//     [P in keyof (T1 & T2)]?: SafeUnionType<P, T1> | SafeUnionType<P, T2>;
// } & {};

type DeepUnion2<T1, T2> = {
    [P in keyof (T1 & T2)]: SafeUnionType<P, T1> | SafeUnionType<P, T2>;
} & {};

type DeepUnion3<T1, T2, T3> = {
    [P in keyof (T1 & T2 & T3)]: SafeUnionType<P, T1> | SafeUnionType<P, T2> | SafeUnionType<P, T3>;
} & {};
type DeepUnion4<T1, T2, T3, T4> = {
    [P in keyof (T1 & T2 & T3 & T4)]:
        | SafeUnionType<P, T1>
        | SafeUnionType<P, T2>
        | SafeUnionType<P, T3>
        | SafeUnionType<P, T4>;
} & {};
type DeepUnion5<T1, T2, T3, T4, T5> = {
    [P in keyof (T1 & T2 & T3 & T4 & T5)]:
        | SafeUnionType<P, T1>
        | SafeUnionType<P, T2>
        | SafeUnionType<P, T3>
        | SafeUnionType<P, T4>
        | SafeUnionType<P, T5>;
} & {};
type DeepUnion6<T1, T2, T3, T4, T5, T6> = {
    [P in keyof (T1 & T2 & T3 & T4 & T5 & T6)]:
        | SafeUnionType<P, T1>
        | SafeUnionType<P, T2>
        | SafeUnionType<P, T3>
        | SafeUnionType<P, T4>
        | SafeUnionType<P, T5>
        | SafeUnionType<P, T6>;
} & {};
type DeepUnion7<T1, T2, T3, T4, T5, T6, T7> = {
    [P in keyof (T1 & T2 & T3 & T4 & T5 & T6 & T7)]:
        | SafeUnionType<P, T1>
        | SafeUnionType<P, T2>
        | SafeUnionType<P, T3>
        | SafeUnionType<P, T4>
        | SafeUnionType<P, T5>
        | SafeUnionType<P, T6>
        | SafeUnionType<P, T7>;
} & {};
type DeepUnion8<T1, T2, T3, T4, T5, T6, T7, T8> = {
    [P in keyof (T1 & T2 & T3 & T4 & T5 & T6 & T7 & T8)]:
        | SafeUnionType<P, T1>
        | SafeUnionType<P, T2>
        | SafeUnionType<P, T3>
        | SafeUnionType<P, T4>
        | SafeUnionType<P, T5>
        | SafeUnionType<P, T6>
        | SafeUnionType<P, T7>
        | SafeUnionType<P, T8>;
} & {};

// type ComposeU<Fns extends any[], Acc = {}> =
//     Fns extends [HOC<infer H>, ...infer T]
//         ? ComposeU<T, DeepUnion2<Acc, H>>
//         : Composition<Acc>;

export function composeU<T1>(fn1: HOC<T1>): Composition<T1>;
export function composeU<T1, T2>(fn1: HOC<T1>, fn2: HOC<T2>): Composition<DeepUnion2<T1, T2>>;
export function composeU<T1, T2, T3>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
): Composition<DeepUnion3<T1, T2, T3>>;
export function composeU<T1, T2, T3, T4>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
): Composition<DeepUnion4<T1, T2, T3, T4>>;
export function composeU<T1, T2, T3, T4, T5>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
): Composition<DeepUnion5<T1, T2, T3, T4, T5>>;
export function composeU<T1, T2, T3, T4, T5, T6>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
): Composition<DeepUnion6<T1, T2, T3, T4, T5, T6>>;
export function composeU<T1, T2, T3, T4, T5, T6, T7>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
    fn7: HOC<T7>,
): Composition<DeepUnion7<T1, T2, T3, T4, T5, T6, T7>>;
export function composeU<T1, T2, T3, T4, T5, T6, T7, T8>(
    fn1: HOC<T1>,
    fn2: HOC<T2>,
    fn3: HOC<T3>,
    fn4: HOC<T4>,
    fn5: HOC<T5>,
    fn6: HOC<T6>,
    fn7: HOC<T7>,
    fn8: HOC<T8>,
): Composition<DeepUnion8<T1, T2, T3, T4, T5, T6, T7, T8>>;
export function composeU(...fns: Array<HOC<any>>): Composition<any>;

// export function composeU<Fns extends HOC<any>[]>(...fns: Fns): ComposeU<Fns> {
export function composeU(...fns: Parameters<typeof composeUBase>) {
    return composeUBase(...fns);
}
